import * as _ from "lodash";
import React, { useState } from "react";
import * as ReactModal from "react-modal";
import * as Models from "../../../Models";
import { Link } from "react-router-dom";
// import { linkAssetToProject } from "../../../Middleware/assetChangeRequest";
import {
    linkAssetToProjectMutation,
    useGetNotLinkedAssets,
} from "../../../Api/azure";
import Loader from "../loader";
import filterItemsStore from "../../../Store/filterItems";
import { toast } from "react-toastify";

interface LinkExistingAssetToProjectProps {
    projectId: string;
    isOpen: boolean;
    siteName: string;
    onClose: () => void;
    alternativeProjectId: string;
}

export default function LinkExistingAssetToProject(
    props: LinkExistingAssetToProjectProps
) {
    const { siteName, projectId, alternativeProjectId, onClose, isOpen } =
        props;
    const [selectedAssetIds, setSelectedAssetIds] = useState<string[]>([]);
    const { data: notLinkedAssets, isPending: isLoading } =
        useGetNotLinkedAssets(siteName);
    const { mutate: linkAssetToProject, isPending: isSubmitting } =
        linkAssetToProjectMutation();
    const { addProjectAssetAttributeGroups } = filterItemsStore();

    function close() {
        // e.stopPropagation();
        onClose();
    }

    function handleCheckboxClick(assetId: string) {
        // Check if the property name is already in the array
        if (selectedAssetIds.includes(assetId)) {
            // Remove it from the array (unselecting)
            setSelectedAssetIds(
                selectedAssetIds.filter((item) => item !== assetId)
            );
        } else {
            // Add it to the array (selecting)
            setSelectedAssetIds((prev) => [...prev, assetId]);
        }
    }

    function handleSelectAllClick() {
        if (selectedAssetIds.length === notLinkedAssets.length) {
            setSelectedAssetIds([]);
        } else {
            const assetIds = notLinkedAssets.map((asset) => asset.name);
            setSelectedAssetIds(assetIds);
        }
    }

    function handleLinkAsset() {
        linkAssetToProject(
            { assetIds: selectedAssetIds, projectId },
            {
                onSuccess: (data) => {
                    addProjectAssetAttributeGroups(
                        data.rows,
                        alternativeProjectId
                    );
                    onClose();
                    toast.success("Asset linked successfully");
                },
                onError: () => {
                    toast.error(`Error Linking asset`);
                },
            }
        );
    }

    const modalContent: JSX.Element = (
        <div className="container" style={{ height: "100%" }}>
            <div className="row">
                <div className="col-lg-12">
                    <h2 className="Modal__header">LINKING EXISTING ASSET</h2>
                </div>
            </div>
            <div
                className="row"
                style={{
                    overflow: "auto",
                    height: "70%",
                    marginTop: 30,
                }}
            >
                {notLinkedAssets?.length > 0 ? (
                    <div className="col-lg-12 table-responsive">
                        <table className="table w-100 m-0">
                            <thead>
                                <tr
                                    style={{
                                        borderBottomColor: "#cccccc",
                                        borderBottomWidth: 1,
                                        borderBottomStyle: "solid",
                                        backgroundColor: "#F2F2F2",
                                        height: 34,
                                    }}
                                >
                                    <th>
                                        <input
                                            type="checkbox"
                                            name="select"
                                            onChange={() =>
                                                handleSelectAllClick()
                                            }
                                            checked={
                                                selectedAssetIds.length ===
                                                notLinkedAssets.length
                                            }
                                        />
                                    </th>
                                    <th scope="col" className="pr-3 me-1 w-33">
                                        Asset Description
                                    </th>
                                    <th scope="col" className="pr-3 me-1 w-33">
                                        Serial Number
                                    </th>
                                    <th scope="col" className="pr-3 me-1 w-33">
                                        Asset ID
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {notLinkedAssets.map(
                                    (property: Models.NotLinkedAssets) => {
                                        return (
                                            <tr
                                                style={{
                                                    lineHeight: 2,
                                                    borderBottomColor:
                                                        "#cccccc",
                                                    borderBottomWidth: 1,
                                                    borderBottomStyle: "solid",
                                                    backgroundColor:
                                                        selectedAssetIds.includes(
                                                            property.name
                                                        )
                                                            ? "lightgrey"
                                                            : null,
                                                }}
                                                key={property.name}
                                                onClick={() =>
                                                    handleCheckboxClick(
                                                        property.name
                                                    )
                                                }
                                            >
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        name="select"
                                                        onClick={(e) =>
                                                            e.stopPropagation()
                                                        }
                                                        onChange={() =>
                                                            handleCheckboxClick(
                                                                property.name
                                                            )
                                                        }
                                                        checked={selectedAssetIds.includes(
                                                            property.name
                                                        )}
                                                    />
                                                </td>
                                                <td
                                                    className="pr-3"
                                                    style={{ width: "35%" }}
                                                >
                                                    <Link
                                                        to={{
                                                            pathname: `/sites/location/${property.alternateId}`,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {
                                                            property.assetDescription
                                                        }
                                                    </Link>
                                                </td>
                                                <td className="pr-3">
                                                    {property.serialNumber ? ( //to avoid making this clickable when serial number is null
                                                        <Link
                                                            to={{
                                                                pathname: `/sites/location/${property.alternateId}`,
                                                            }}
                                                            target="_blank"
                                                        >
                                                            {
                                                                property.serialNumber
                                                            }
                                                        </Link>
                                                    ) : (
                                                        "  -"
                                                    )}
                                                </td>
                                                <td className="pr-3">
                                                    <Link
                                                        to={{
                                                            pathname: `/sites/location/${property.alternateId}`,
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {property.name}
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="col-lg-12">No Assets to link</div>
                )}
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div
                        className="btn-group"
                        role="group"
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: 10,
                        }}
                    >
                        <button
                            className="btn btn-secondary me-2"
                            onClick={(e) => close()}
                        >
                            Close
                        </button>
                        <button
                            className="btn btn-primary me-2"
                            onClick={() => handleLinkAsset()}
                            disabled={
                                selectedAssetIds?.length == 0 || isSubmitting
                            }
                        >
                            Link
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <ReactModal
            onRequestClose={() => onClose()}
            isOpen={isOpen}
            contentLabel="Modal"
            style={{
                content: {
                    height: "80%",
                },
            }}
            defaultStyles={{}}
        >
            {isLoading ? <Loader /> : modalContent}
        </ReactModal>
    );
}
